import styles from "./button.module.css";
import { Spinner } from "react-bootstrap";

function Button({
  handleClick,
  disabled,
  heading,
  place,
  width = "",
  loading = false,
  type = "button",
  marginTop = "20px",
  height,
}) {
  const handleButtonClick = (event) => {
    event.preventDefault();
    if (!disabled && !loading) {
      handleClick(event);
    }
  };

  return (
    <div
      className={styles.loginButton}
      style={{
        justifyContent: place === "center" ? "center" : undefined,
        marginTop: marginTop,
        height: height,
      }}
    >
      <button
        type={type}
        className={styles.createAccount}
        onClick={handleButtonClick}
        disabled={disabled || loading}
        style={{
          width: width !== "" ? width : undefined,
        }}
      >
        {loading && (
          <Spinner
            animation="border"
            size="sm"
            style={{ width: "12px", height: "12px", marginRight: "5px" }}
          />
        )}{" "}
        {heading}
      </button>
    </div>
  );
}

export default Button;
